.content {
  color: #666;
}

.process {
  margin-bottom: 18px;
  color: #222;
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
}

.timeline {
  position: relative;
  margin: 0;
  padding: 0 0 10px 21px;
  list-style: none;
}
.timeline::before {
  position: absolute;
  top: 9px;
  bottom: 20px;
  left: 7px;
  width: 1px;
  background: #d4d4d4;
  content: "";
}

.event {
  position: relative;
  min-height: 94px;
  padding-bottom: 17px;
}

.marker {
  position: absolute;
  top: 0;
  left: -21px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid #00a878;
  border-radius: 50%;
  background: #fff;
  color: #00a878;
}

.eventContent {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  line-height: 1.25;
}
.eventContent strong {
  margin-bottom: 1px;
  color: #222;
  font-size: 13px;
}

.feedback {
  margin: 25px 0;
  font-size: 13px;
}

.footer {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL3BhZ2VzL0RlbGF5TWFuYWdlbWVudC9mcmFnbWVudHMvSnVzdGlmaWNhdGlvbkhpc3RvcnkiLCJzb3VyY2VzIjpbIkp1c3RpZmljYXRpb25IaXN0b3J5Lm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7OztBQUlKO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIuY29udGVudCB7XG4gIGNvbG9yOiAjNjY2O1xufVxuXG4ucHJvY2VzcyB7XG4gIG1hcmdpbi1ib3R0b206IDE4cHg7XG4gIGNvbG9yOiAjMjIyO1xuICBmb250LXNpemU6IDE0cHg7XG4gIGZvbnQtd2VpZ2h0OiB2YXIoLS1mb250LXdlaWdodC1zZW1pYm9sZCk7XG59XG5cbi50aW1lbGluZSB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgbWFyZ2luOiAwO1xuICBwYWRkaW5nOiAwIDAgMTBweCAyMXB4O1xuICBsaXN0LXN0eWxlOiBub25lO1xuXG4gICY6OmJlZm9yZSB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHRvcDogOXB4O1xuICAgIGJvdHRvbTogMjBweDtcbiAgICBsZWZ0OiA3cHg7XG4gICAgd2lkdGg6IDFweDtcbiAgICBiYWNrZ3JvdW5kOiAjZDRkNGQ0O1xuICAgIGNvbnRlbnQ6IFwiXCI7XG4gIH1cbn1cblxuLmV2ZW50IHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBtaW4taGVpZ2h0OiA5NHB4O1xuICBwYWRkaW5nLWJvdHRvbTogMTdweDtcbn1cblxuLm1hcmtlciB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwO1xuICBsZWZ0OiAtMjFweDtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIHdpZHRoOiAxNnB4O1xuICBoZWlnaHQ6IDE2cHg7XG4gIGJvcmRlcjogMXB4IHNvbGlkICMwMGE4Nzg7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgYmFja2dyb3VuZDogI2ZmZjtcbiAgY29sb3I6ICMwMGE4Nzg7XG59XG5cbi5ldmVudENvbnRlbnQge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBnYXA6IDRweDtcbiAgZm9udC1zaXplOiAxMXB4O1xuICBsaW5lLWhlaWdodDogMS4yNTtcblxuICBzdHJvbmcge1xuICAgIG1hcmdpbi1ib3R0b206IDFweDtcbiAgICBjb2xvcjogIzIyMjtcbiAgICBmb250LXNpemU6IDEzcHg7XG4gIH1cbn1cblxuLmZlZWRiYWNrIHtcbiAgbWFyZ2luOiAyNXB4IDA7XG4gIGZvbnQtc2l6ZTogMTNweDtcbn1cblxuLmZvb3RlciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gIHdpZHRoOiAxMDAlO1xufVxuIl19 */